import { createElement, forwardRef } from 'react'
import { mergeCss } from '../css/css.mjs';
import { splitProps } from '../helpers.mjs';
import { getListItemStyle } from '../patterns/list-item.mjs';
import { styled } from './factory.mjs';

export const ListItem = /* @__PURE__ */ forwardRef(function ListItem(props, ref) {
  const [patternProps, restProps] = splitProps(props, ["disablePadding"])

const styleProps = getListItemStyle(patternProps)
const cssProps = { css: mergeCss(styleProps, props.css) }
const mergedProps = { ref, ...restProps, ...cssProps }

return createElement(styled.li, mergedProps)
  })